import { CSSObject, Theme, getFontWeight } from '@core-ui/react-stitch';
import getTextStyles from '../getTextStyles';

export const getFullHexColor = (hex: string, transparency?: string) => {
  const fullHexColor = hex.length < 5 ? hex + hex.substring(1) : hex;
  return transparency ? fullHexColor + transparency : fullHexColor;
};

const getOptionStyles = (isBRRedesignEnabled: boolean) => (
  base: CSSObject, 
  { theme }: { theme: Theme; }
): CSSObject => ({
  ...base,
  ...getTextStyles(isBRRedesignEnabled),
  ...isBRRedesignEnabled ? {
    color: theme.color.b2,
    backgroundColor: theme.color.inverse.b1,
    fontWeight: getFontWeight('regular').fontWeight,
    '&:hover': {
      backgroundColor: theme.color.wh,
    },
    '&[aria-selected="true"]': {
      backgroundColor: getFullHexColor(theme.color.b1, '1A'),
    }
  } : {}
});

export default getOptionStyles;
